﻿<template>
    <section v-if="cartNotEmpty() && Addons?.length > 0" class="ao">
        <div v-if="!showAddons" class="ao-loading" role="status" aria-live="polite">
            <p>
                <svg class="ts-spinner" viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3" opacity="0.25" /><path d="M22 12a10 10 0 0 0-10-10" stroke="currentColor" stroke-width="3" stroke-linecap="round" /></svg>
                Loading add-ons for {{ Trip_Name() }}…
            </p>
        </div>

        <div id="addon-section" v-else :hidden="Addons?.length == 0">
            <div class="ao-head">
                <h3>Optional add-ons for {{Trip_Name()}}</h3>
                <p>{{Add_On_Message()}}</p>
            </div>

            <div class="ao-list">
                <article class="ao-item" v-for="product in sort_Add_ons(Addons)" :key="product.tour_id" :id="'add_on_' + product.tour_id">
                    <img class="ao-image" :src="image(product)" :alt="imageAltText(product)">
                    <div class="ao-body">
                        <h4 class="ao-title">{{product.name}}</h4>
                        <div class="ao-desc" v-html="product.description_short"></div>
                        <select_passengers :price="price(product)" :tour_details="product" :passengers="get_Booking_Passengers()" :parent_tour_id="trip?.tour_id" :tour_id="product.tour_id" :departure_date="trip?.departure_date"></select_passengers>
                    </div>
                </article>
            </div>
        </div>
    </section>
</template>

<script lang="ts" src="./add-ons.ts"></script>